<template>
  <RouterLink v-slot="{ navigate }" custom :to="to" :replace="replace">
    <Tab v-bind="$attrs" @activate="navigate" @register="setTabIndex">
      <slot></slot>
    </Tab>
  </RouterLink>
</template>

<script setup>
import { inject, ref, watch, defineOptions } from 'vue'
import { useRoute, useRouter, RouterLink } from 'vue-router'
import { tabKey } from './key'
import Tab from './Tab'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  to: { type: [String, Object], required: true },
  replace: { type: Boolean, default: false },
})

// This is a bit of a kludge. Is there a better way to get the index here other than emitting it from Tab?
const tabIndex = ref(null) // Index of the tab in the tablist, not tabindex for focus
const setTabIndex = (index) => {
  tabIndex.value = index
}

const tabsState = inject(tabKey)
const route = useRoute()
const router = useRouter()

// Sets active tab when the tab index is first registered.
watch(tabIndex, () => {
  const resolved = router.resolve(props.to)
  if (resolved.path === route.path || resolved.name === route.name) {
    tabsState.activateTab(tabIndex.value)
  }
})

// Sometimes the router isn't ready at the time the tab is registered, so we need to watch for the
// first route change to set the active tab.
watch(
  () => route.path,
  () => {
    const resolved = router.resolve(props.to)
    if (
      (resolved.path === route.path || resolved.name === route.name) &&
      tabsState.activeIndex.value !== tabIndex.value
    ) {
      tabsState.activateTab(tabIndex.value)
    }
  },
)
</script>
